import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FolderCard = ({ folder, onOpen, onRename, onDelete }) => {
  const [isHovered, setIsHovered] = useState(false);

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div
      className="relative bg-card border border-border rounded-lg p-4 transition-luxury hover:elevation-2 cursor-pointer group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onOpen(folder)}
    >
      {/* Folder Icon */}
      <div className="flex items-center justify-center mb-4 aspect-square">
        <div className="relative">
          <Icon
            name="Folder"
            size={64}
            color="var(--color-accent)"
            className="drop-shadow-sm"
          />
          {folder?.fileCount > 0 && (
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-accent text-accent-foreground rounded-full flex items-center justify-center text-xs font-medium">
              {folder?.fileCount > 99 ? '99+' : folder?.fileCount}
            </div>
          )}
        </div>
      </div>
      {/* Folder Info */}
      <div className="space-y-2">
        <h3 className="font-medium text-foreground truncate" title={folder?.name}>
          {folder?.name}
        </h3>
        
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{folder?.fileCount} files</span>
          <span>{formatDate(folder?.lastModified)}</span>
        </div>

        {folder?.description && (
          <p className="text-xs text-muted-foreground line-clamp-2">
            {folder?.description}
          </p>
        )}
      </div>
      {/* Quick Actions */}
      {isHovered && (
        <div className="absolute top-3 right-3 flex space-x-1">
          <Button
            variant="ghost"
            size="icon"
            className="w-6 h-6 bg-background/80 backdrop-blur-sm"
            onClick={(e) => {
              e?.stopPropagation();
              onRename(folder);
            }}
          >
            <Icon name="Edit2" size={12} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="w-6 h-6 bg-background/80 backdrop-blur-sm text-error hover:text-error"
            onClick={(e) => {
              e?.stopPropagation();
              onDelete(folder);
            }}
          >
            <Icon name="Trash2" size={12} />
          </Button>
        </div>
      )}
    </div>
  );
};

export default FolderCard;